import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { Button, Col, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import Link from 'antd/lib/typography/Link';

import { RootState } from '../../modules';
import { USER_ROLE_NAME } from '../../modules/auth';

interface JoinMemberStep4Props {
  moveToMainPage: (enterpriseId: string) => void;
  moveToLoginPage: () => void;
}

function JoinMemberStep4({
  moveToMainPage,
  moveToLoginPage,
}: JoinMemberStep4Props) {
  const user = useSelector((state: RootState) => state.auth.auth.data);

  return (
    <>
      {user !== null && (
        <Row justify="center" style={{ marginTop: isMobile ? '10px' : '50px' }}>
          <Col span={18}>
            <Title level={4}>
              {user.name}님! 회원가입을 완료 하였습니다.{' '}
              {isMobile
                ? '하이공사 모바일앱을 다운로드 하세요.'
                : user.roleName !== USER_ROLE_NAME.ADMIN
                ? '로그인 페이지로 이동하세요.'
                : '메인 페이지로 이동하세요.'}
            </Title>
          </Col>
        </Row>
      )}
      {!isMobile && (
        <Row justify="center" style={{ marginTop: isMobile ? '10px' : '50px' }}>
          {user === null ? (
            <Title level={5}>회원가입을 실패 하였습니다.</Title>
          ) : user.roleName !== USER_ROLE_NAME.ADMIN ? (
            <Button
              type="primary"
              size="large"
              onClick={() => moveToLoginPage()}
            >
              로그인 페이지로 이동하기
            </Button>
          ) : (
            <Button
              type="primary"
              size="large"
              onClick={() => moveToMainPage('' + user.myEnterprise.id)}
            >
              메인페이지로 이동하기
            </Button>
          )}
        </Row>
      )}

      {isMobile && (
        <Row
          justify={'center'}
          align={'middle'}
          style={{ marginTop: isMobile ? '10px' : '50px' }}
        >
          <Col>
            <Link
              href="https://apps.apple.com/kr/app/%ED%95%98%EC%9D%B4%EA%B3%B5%EC%82%AC/id6469765108"
              target="_blank"
            >
              <img
                src={`${process.env.PUBLIC_URL}/img/appstore-logo.png`}
                alt="appstore-logo"
                style={{ width: '150px' }}
              />
            </Link>
          </Col>
        </Row>
      )}
      {isMobile && (
        <Row
          justify={'center'}
          align={'middle'}
          style={{ marginTop: isMobile ? '10px' : '50px' }}
        >
          <Col>
            <Link
              href="https://play.google.com/store/apps/details?id=com.higongsa.higongsa_mobile_app&pcampaignid=web_share"
              target="_blank"
            >
              <img
                src={`${process.env.PUBLIC_URL}/img/google-play-logo.png`}
                alt="google-play-logo"
                style={{ width: '150px' }}
              />
            </Link>
          </Col>
        </Row>
      )}
    </>
  );
}
export default JoinMemberStep4;
